package com.appcreator.client.firebase.storage

import coil3.PlatformContext
import dev.gitlive.firebase.storage.File
import io.github.vinceglb.filekit.PlatformFile
import io.github.vinceglb.filekit.extension
import io.github.vinceglb.filekit.name

actual fun PlatformFile.toFile(): File = file
actual fun PlatformFile.toPath(): String = file.toString()

actual fun PlatformFile.getMimeTypeFromExtension(): String? {
    return when (extension) {
        "jpg", "jpeg" -> "image/jpeg"
        "png" -> "image/png"
        "gif" -> "image/gif"
        "pdf" -> "application/pdf"
        "doc" -> "application/msword"
        "docx" -> "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        "xls" -> "application/vnd.ms-excel"
        "xlsx" -> "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        "mp4" -> "video/mp4"
        "mp3" -> "audio/mpeg"
        "zip" -> "application/zip"
        "txt" -> "text/plain"
        "json" -> "application/json"
        "heic" -> "image/heic"
        else -> null
    }
}

actual fun PlatformFile.heicToJpeg(context: PlatformContext): File? {
   return null
}

actual fun File.delete() {
}